export const { PUBLIC_URL } = process.env

export function formatNumber(number) {
  const backwardsNumString = [...`${number}`]
    .reverse()
    .join('')
    .split(/(.{3})/g)
    .filter(Boolean)
    .join(',')
  return [...backwardsNumString].reverse().join('')
}

export function formatBytes(number) {
  if (typeof number === 'number') {
    if (number >= 1_000_000_000) {
      return `${(number / 1_000_000_000).toFixed(2)}GB`
    }
    if (number >= 1_000_000) {
      return `${(number / 1_000_000).toFixed(2)}MB`
    }
    if (number >= 1_000) {
      return `${(number / 1_000).toFixed(2)}KB`
    }
    return `${formatNumber(number)}B`
  }
}
